import { render, staticRenderFns } from "./EiHomeBlock4.vue?vue&type=template&id=b1976b94&scoped=true&"
import script from "./EiHomeBlock4.vue?vue&type=script&lang=js&"
export * from "./EiHomeBlock4.vue?vue&type=script&lang=js&"
import style0 from "./EiHomeBlock4.vue?vue&type=style&index=0&id=b1976b94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1976b94",
  null
  
)

export default component.exports